import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

Pusher.Runtime.createXHR = function () {
  return new XMLHttpRequest();
};

let echoInstance = null;

export const getEchoInstance = () => {
  if (echoInstance) return echoInstance;
  const key = process.env.REACT_APP_PUSHER_KEY || 'local';
  const wsHost = process.env.REACT_APP_PUSHER_HOST || window.location.hostname;
  const wsPort = process.env.REACT_APP_PUSHER_PORT || 6001;

  echoInstance = new Echo({
    broadcaster: 'pusher',
    key,
    wsHost,
    wsPort,
    forceTLS: false,
    disableStats: true,
    authEndpoint: `${process.env.REACT_APP_API_URL || 'http://localhost:8000/api'}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
      },
    },
  });

  return echoInstance;
};







